// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"409":"b8c971a7","453":"de9d6057","501":"a6fe1f05"}[chunkId] + ".chunk.js";
};